import AppHeaderDesktop from "./AppHeaderDesktop";
import AppHeaderMobile from "./AppHeaderMobile";

const AppHeader = () => {
  return (
    <header className="sticky top-0 z-20">
      <div className="hidden lg:block">
        <AppHeaderDesktop />
      </div>
      <div className="block lg:hidden">
        <AppHeaderMobile />
      </div>
    </header>
  );
};

export default AppHeader;
